import script from "./WashingMark.vue?vue&type=script&lang=ts&setup=true"
export * from "./WashingMark.vue?vue&type=script&lang=ts&setup=true"

import "./WashingMark.vue?vue&type=style&index=0&id=656e0749&lang=scss"
import "./WashingMark.vue?vue&type=style&index=1&id=656e0749&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-656e0749"]])

export default __exports__